import { lazy } from "react";
import { BookOpen } from "lucide-react";

import type { FeatureDescriptor } from "@/features/types";

/**
 * Glossary — short definitions of every term the pages use. It has no data of its
 * own: it renders the term registry (`boond_contracts/terms.py`) served through
 * `/meta/config`, so it can only say what the hover hints and the assistant say.
 */
export const glossaryFeature: FeatureDescriptor = {
  id: "glossary",
  flag: "glossary",
  path: "/glossary",
  group: "help",
  navKey: "nav.glossary",
  icon: BookOpen,
  element: lazy(() => import("./GlossaryPage")),
};
